import moment from 'moment';

export const WidgetEnums = {
    TOTAL_VENDOR_PAID: 'TOTAL_VENDOR_PAID',
    SNAPSHOT: 'SNAPSHOT',
    TOTAL_BILLED: 'TOTAL_BILLED',
    PERIODIC: 'PERIODIC',

    PAYABLE: 'PAYABLE',
    BILLING: 'BILLING',
    VENDOR : 'VENDOR',
    PROCESSING : 'PROCESSING',
    RECEIVABLES : 'RECEIVABLES',
}

export const WidgetCategories = [
    {name: 'Billing', id: WidgetEnums.BILLING },
    {name: 'Payable', id: WidgetEnums.PAYABLE },
    {name: 'Vendor', id: WidgetEnums.VENDOR },
    {name: 'Processing', id: WidgetEnums.PROCESSING },
    {name: 'Receivables', id: WidgetEnums.RECEIVABLES },
    // {name: 'Vendor Paid', id: WidgetEnums.TOTAL_VENDOR_PAID },
    // {name: 'Snapshot', id: WidgetEnums.SNAPSHOT },
    // {name: 'Total Billed', id: WidgetEnums.TOTAL_BILLED },
    // {name: 'Periodic', id: WidgetEnums.PERIODIC },
]

export const DataTypes = {
    SNAPSHOT: 'SNAPSHOT',
    PERIODIC: 'PERIODIC',
};

export const ValueTypes = {
    NUMBER: 'NUMBER',
    DOLLAR: 'DOLLAR',
    PERCENT: 'PERCENT',
};

export const checkFilter = (inputs, i) => {
    if (inputs?.category) {
        return i?.category === inputs?.category
    }
    return true
}


export const ValueFormatter = (value, valueType) => {
    switch (valueType) {
        case ValueTypes.NUMBER:
            return value;
        case ValueTypes.DOLLAR:
            return `$${value}`;
        case ValueTypes.PERCENT:
            return `%${value}`;
        default:
            return value;
    }
}


export const DefaultDates = ( info ) => {
    const startDate = moment().startOf('year');
    const endDate = moment().endOf('year');
    // const prevStartDate = moment().subtract(1, 'year').startOf('year');
    // const prevEndDate = moment().subtract(1, 'year').endOf('year');


    const allDates = {
        startDate: info?.startDate ? info?.startDate :  startDate.format('YYYY-MM-DD'),
        endDate: info?.endDate ?  info?.endDate : endDate.format('YYYY-MM-DD'),
        // prevStartDate: info?.prevStartDate ?  info?.prevStartDate : prevStartDate.format('YYYY-MM-DD'),
        // prevEndDate: info?.prevEndDate ?  info?.prevEndDate : prevEndDate.format('YYYY-MM-DD'),
    }
    return {
        allDates
    }
}
